import React from 'react';

export default class AddIntegration extends React.Component {
	render() {
		return null;
	}
}
